import { render } from "./AboutAKitty.vue?vue&type=template&id=d0b54fb6"
import script from "./AboutAKitty.vue?vue&type=script&lang=js"
export * from "./AboutAKitty.vue?vue&type=script&lang=js"

import "./AboutAKitty.vue?vue&type=style&index=0&id=d0b54fb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__